import { DATE_VALUES, getRangeFromDateFilter } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  CACHE_KEY_REQUEST_ASYNC,
  CAMPAIGN_FILTER_CHANGE,
  CAMPAIGNS_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  REPORT_REQUEST_ASYNC,
} from './constants'

const initialState = {
  loader: false,
  data: {
    reportData: {},
    campaigns: [],
    withcustomIds: false,
  },
  cacheKey: null,
  error: null,
  dateFilter: DATE_VALUES.DAYS_BACK_90,
}

export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case CAMPAIGNS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
          cacheKey: null,
        }
      case CAMPAIGNS_REQUEST_ASYNC.SUCCESS:
        /*
          take selected campaign ids from the BE if:
          1. user selected a date filter and not specific campaigns
        */
        // payload.data can be an empty object (e.g. the mock fallback response)
        const receivedCampaigns = action.payload?.data?.campaigns ?? []
        let selectedCampaignsArray = state.data.selectedCampaignIds
        if (!state.data.withcustomIds?.length) {
          selectedCampaignsArray = receivedCampaigns.map((campaign) => campaign.id)
        }
        return {
          ...state,
          loader: false,
          dateFilter:
            state.data.withcustomIds && action.payload?.data?.dateFilter
              ? action.payload.data.dateFilter
              : state.dateFilter,
          data: {
            ...state.data,
            campaigns: receivedCampaigns,
            selectedCampaignIds: selectedCampaignsArray,
            reportData: {},
            withcustomIds: false,
            dateRangeParsed: action.payload?.data?.dateRangeParsed,
          },
        }
      case CAMPAIGNS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case CAMPAIGNS_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          dateFilter: DATE_VALUES.DAYS_BACK_90,
          dateRange: getRangeFromDateFilter(DATE_VALUES.DAYS_BACK_90),
        }
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.value,
          dateRange: getRangeFromDateFilter(action.payload.value),
          data: {
            ...state.data,
            selectedCampaignIds: null,
            reportData: {},
          },
          loader: true,
          cacheKey: null,
        }
      case CAMPAIGN_FILTER_CHANGE: {
        // dateFilter null means "All times" (DATE_VALUES.ALL_TIME) — keep the
        // current filter only when the action didn't pass one at all.
        const nextDateFilter =
          action.payload.dateFilter !== undefined ? action.payload.dateFilter : state.dateFilter
        return {
          ...state,
          loader: false,
          dateFilter: nextDateFilter,
          dateRange: getRangeFromDateFilter(nextDateFilter),
          data: {
            ...state.data,
            withcustomIds: action.payload.withCustomIds,
            selectedCampaignIds: action.payload.selectedCampaignIds,
            reportData: {},
          },
        }
      }
      case REPORT_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case REPORT_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...state.data,
            reportData: action.payload.data,
          },
          loader: false,
          cacheKey: null,
        }
      case REPORT_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case CACHE_KEY_REQUEST_ASYNC.INITIATE:
        return { ...state, cacheKey: null, loader: true }
      case CACHE_KEY_REQUEST_ASYNC.SUCCESS:
        return { ...state, cacheKey: action.payload.key, loader: false }
      case CACHE_KEY_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      default:
        return state
    }
  }
}
